// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD_dPNRZAUSHynU9nyzrIXGeOGZHuKw3mk",
    authDomain: "clapapp-29644.firebaseapp.com",
    databaseURL: "https://clapapp-29644.firebaseio.com",
    projectId: "clapapp-29644",
    storageBucket: "clapapp-29644.appspot.com",
    messagingSenderId: "806890143561",
    appId: "1:806890143561:web:1f15bb4f15588768b76498"
  }
};
